const policy = [
    {
        name: "Free ship",
        description: "Free shipping with orders > 239K",
        icon: "bx bx-shopping-bag"
    },
    {
        name: "Payment COD",
        description: "Payment on delivery (COD)",
        icon: "bx bx-credit-card"
    },
    {
        name: "VIP customers",
        description: "Special offers for VIP customers",
        icon: "bx bx-diamond"
    },
    {
        name: "Warranty support",
        description: "Exchange, repair at all stores",
        icon: "bx bx-donate-heart"
    }
]

export default policy